<script lang="ts">
    import { link } from 'svelte-spa-router';
    export let active: 'status' | 'users' | 'invites' | 'deliveries' | 'ballots' | 'dashboards' | 'retrospective' = 'status';
</script>

<nav class="admin-nav" aria-label="Admin sections">
    <a href="/admin/status"  use:link class:active={active === 'status'}>Status</a>
    <a href="/admin/users"   use:link class:active={active === 'users'}>Users</a>
    <a href="/admin/invites" use:link class:active={active === 'invites'}>Invites</a>
    <a href="/admin/deliveries" use:link class:active={active === 'deliveries'}>Data deliveries</a>
    <a href="/admin/ballots" use:link class:active={active === 'ballots'}>Early vote</a>
    <a href="/admin/dashboards" use:link class:active={active === 'dashboards'}>Dashboards</a>
    <a href="/admin/retrospective" use:link class:active={active === 'retrospective'}>Retrospective</a>
    <a href="/map" use:link class="back-to-map" aria-label="Back to map" title="Back to map">
        <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
            <path d="M19 12H5M12 19l-7-7 7-7"
                  fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Map</span>
    </a>
</nav>

<style>
    .admin-nav {
        display: flex;
        gap: 0;
        border-bottom: 1px solid var(--rule);
        margin-bottom: var(--s-6);
        flex-wrap: wrap;
        align-items: stretch;
    }
    .admin-nav a {
        padding: 12px 18px;
        text-decoration: none;
        color: var(--ink-muted);
        font-family: var(--font-body);
        font-weight: 600;
        font-size: 0.78rem;
        text-transform: uppercase;
        letter-spacing: 0.12em;
        border-bottom: 2px solid transparent;
        margin-bottom: -1px;
        transition: color 0.12s ease, border-color 0.12s ease;
    }
    .admin-nav a:hover { color: var(--ink); }
    .admin-nav a.active {
        color: var(--ink);
        border-bottom-color: var(--ink);
    }
    .back-to-map {
        margin-left: auto;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        color: var(--leaf-bright) !important;
        border-bottom-color: transparent !important;
    }
    .back-to-map:hover {
        color: var(--leaf) !important;
    }
</style>
